import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSave,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Modal } from "bootstrap"; // Import Bootstrap Modal
import {
  useGetPaymentListQuery,
  useUpdatePaymentModeMutation,
} from "../../Services/PaymentmodeAPI";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import CryptoJS from "crypto-js";


function List() {
  const { data, isLoading, error, refetch } = useGetPaymentListQuery();
  const [updatePaymentMode] = useUpdatePaymentModeMutation();


  const encryptData = (data) => {
    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
    const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

    if (!key || !iv) {
      console.error("Encryption key or IV is missing!");
      return null;
    }

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  };

  const decryptData = (encryptedData) => {
    try {
      const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
      const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

      if (!key || !iv) {
        console.error("Decryption key or IV is missing!");
        return null;
      }

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)); // Parse JSON if necessary
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  const [modalData, setModalData] = useState({
    id: null,
    field: "",
    value: "",
  });

  if (isLoading) return <div className="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  // const handleInputChange = (id, field, value) => {
  //     setEditableFields((prev) => ({
  //         ...prev,
  //         [id]: {
  //             ...prev[id],
  //             [field]: value,
  //         },
  //     }));
  // };

  const openModal = (id, field, value) => {
    setModalData({ id, field, value });

    setTimeout(() => {
      const modalElement = document.getElementById("editModal");
      const modalInstance = new Modal(modalElement);
      modalInstance.show();
    }, 100);
  };

  const handleSave = async (mode, updatedFields = {}) => {
    const updatedData = {
      name: mode.name,
      status:
        updatedFields.status !== undefined ? updatedFields.status : mode.status,
      public_key: updatedFields.public_key
        ? encryptData(updatedFields.public_key)
        : mode.public_key,
      secret_key: updatedFields.secret_key
        ? encryptData(updatedFields.secret_key)
        : mode.secret_key,
      webhook_id: updatedFields.webhook_id
        ? encryptData(updatedFields.webhook_id)
        : mode.webhook_id,
    };

    try {
      await updatePaymentMode({ formData: updatedData, id: mode.id }).unwrap();
      await refetch();
      alert("Payment mode updated successfully!");
    } catch (err) {
      console.error("Error updating payment mode:", err);
    }
  };

  const handleModalSave = () => {
    if (modalData.id && modalData.field) {
      const mode = data.payment_modes.find((mode) => mode.id === modalData.id);

      if (mode) {
        handleSave(mode, { [modalData.field]: modalData.value }); // Only update the selected key field
      }
    }

    const modalElement = document.getElementById("editModal");
    const modalInstance = Modal.getInstance(modalElement);
    if (modalInstance) {
      modalInstance.hide();
    }

    setModalData({ id: null, field: "", value: "" });
  };

  const maskKey = (key) => {
    if (!key || key.length < 6) return "******"; // Handle very short keys
    return (
      key.substring(0, 3) +
      "*********************" +
      key.substring(key.length - 3)
    );
  };
  return (
    <div>
      <h3>
        Payment Modes
        <div className="tooltip-container">
          <FontAwesomeIcon
            icon={faCircleInfo}
            className="text-warning mx-2"
            style={{ cursor: "pointer" }}
          />
          <div className="tooltip">
            The selected option will be displayed in the payment option section.
          </div>
        </div>
      </h3>
      <p style={{color:"red", fontSize:"13px"}}><i>If you add the public key, secret key, and webhook ID for Stripe, or the client ID and secret ID for PayPal, only then will it be displayed correctly </i></p>
      <div className="content-wrapper">
        <div>
          {!(data?.payment_modes && data.payment_modes.length > 0) && (
            <div className="row justify-content-end mb-3">
              <div className="col-auto">
                <Link to="/add-payment-methods">
                  <button className="btn btn-primary">
                    <FontAwesomeIcon icon={faPlus} className="mx-2" /> Add new
                  </button>
                </Link>
              </div>
            </div>
          )}

          <div className="mt-4 table-responsive">
            <table className="table table-bordered payment-mode-table">
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th>Payment Method</th>
                  <th className="key-head">Public Key / Client ID</th>
                  <th className="key-head">Secret Key</th>
                  <th className="key-head">
                    Webhook ID
                    <div className="tooltip-container">
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="text-warning mx-2"
                        style={{ cursor: "pointer" }}
                      />
                      <div className="tooltip">
                        Create a webhook endpoint in your Stripe account using
                        the following URL format:
                        <br />
                        <strong>
                          Your backend base URL/api/stripe/webhook
                        </strong>
                        <br />
                        Example:
                        <strong>
                          https://yourbackendurl.com/api/stripe/webhook
                        </strong>
                      </div>
                    </div>
                  </th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.payment_modes?.map((mode, index) => (
                  <tr key={mode.id}>
                    <td>{index + 1}</td>
                    <td>{mode.name}</td>
                    {mode.name !== "Cash on delivery" ? (
                      <>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={mode.public_key ? maskKey(decryptData(mode.public_key)) : ""}
                            onClick={() =>
                              openModal(mode.id, "public_key", decryptData(mode.public_key))
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              mode.secret_key ? maskKey(decryptData(mode.secret_key)) : ""
                            }
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openModal(mode.id, "secret_key", decryptData(mode.secret_key))
                            }
                          />
                          {/* <button
                                                        className="btn btn-sm btn-secondary mx-2 payment-mode-edit-button"
                                                        onClick={() => openModal(mode.id, "secret_key", mode.secret_key)}
                                                    >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button> */}
                        </td>
                      </>
                    ) : (
                      <>
                        <td>-</td>
                        <td>-</td>
                      </>
                    )}
                    {(mode.name !== "Cash on delivery") &
                      (mode.name !== "paypal") ? (
                      <>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              mode.webhook_id ? maskKey(decryptData(mode.webhook_id)) : ""
                            }
                            onClick={() =>
                              openModal(mode.id, "webhook_id", decryptData(mode.webhook_id))
                            } // Open modal on click
                            style={{ cursor: "pointer" }} // Change cursor to indicate clickability
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <td>-</td>
                      </>
                    )}
                    <td>
                      <input
                        type="checkbox"
                        checked={mode.status === 1}
                        onChange={() =>
                          handleSave(mode, {
                            status: mode.status === 1 ? 0 : 1,
                          })
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      <div
        className="modal fade edit-key-modal"
        id="editModal"
        tabIndex="-1"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editModalLabel">
                Update{" "}
                {modalData.field === "public_key"
                  ? "Public Key"
                  : modalData.field === "secret_key"
                    ? "Secret Key"
                    : "Webhook ID"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <input
                type="text"
                className="form-control"
                value={modalData.value}
                onChange={(e) =>
                  setModalData((prev) => ({ ...prev, value: e.target.value }))
                }
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={handleModalSave}
              >
                <FontAwesomeIcon icon={faSave} className="save-icon" /> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default List;
